import { erpApi } from "@/shared/axios"
import { urlBackend } from "@/shared/constants"
import { AlertSeverityEnum, UseFetchEnabledParams, UseMutationsParams } from "@/shared/interfaces"
import { IOrdenServicioCorporativo, IOrdenServicioCorporativoResp } from "@/shared/interfaces/erp/orden_servicio_corporativo"
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils"
import { useUiStore } from "@/store/ui"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

const { get, post, put } = erpApi()

export const useGetOrdenServicioCorporativo = ({ params, enabled }: UseFetchEnabledParams<GetServicioCorporativaParams>) => {
  return useQuery({
    queryKey: ['OrdenServicioCorporativo', ...Object.values(params || {})],
    queryFn: async () => {
      return getOrdenServicioCorporativo(params)
    },
    enabled,
    refetchOnWindowFocus: false
  })
}

export const useGetOrdenServicioCorporativoById = (id: string) => {
  return useQuery({
    queryKey: ['OrdenServicioCorporativo', id],
    queryFn: async () => {
      return getOrdenServicioCorporativoById(id)
    }
  })
}
export const usePostOrdenServicioCorporativo = ({
  navigate,
  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: postOrdenServicioCorporativo,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['OrdenServicioCorporativo'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);
      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Servicio Corporativa creado correctamente', AlertSeverityEnum.success
        )
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnErrorUrl || ''));
      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false)
    }
  })

}


export const usePutOrdenServicioCorporativo = ({
  navigate,
  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: (params: UpdateServicioCorporativaParams) => putOrdenServicioCorporativo(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['OrdenServicioCorporativo'] });

      //queryClient.invalidateQueries({ queryKey: ['OrdenServicioCorporativo', data.data.id_orden_servicio_corporativo] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);
      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Servicio Corporativa creado correctamente', AlertSeverityEnum.success
        )
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnErrorUrl || ''));
      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false)
    }
  })

}

//axios
export type GetServicioCorporativaParams = Partial<IOrdenServicioCorporativo> & {
  page?: number,
  page_size?: number
}
export type CreateServicioCorporativaParams = Omit<IOrdenServicioCorporativo, 'id_servicio_corporativa'>;
export type UpdateServicioCorporativaParams = {
  id: string;
  data: Partial<CreateServicioCorporativaParams>;
}

//consultas _all-get
export const getOrdenServicioCorporativo = async (params?: GetServicioCorporativaParams) => {
  const queryParams = getUrlParamsFetch({ ...params });
  return get<IOrdenServicioCorporativoResp>(`${urlBackend}api/v1/OrdenServicioCorporativo/?${queryParams}`, true)
}
//get-id
export const getOrdenServicioCorporativoById = async (id: string) => {
  try {
    return await get<IOrdenServicioCorporativo>(`${urlBackend}api/v1/OrdenServicioCorporativo/${id}/`, true);
  } catch (error) {
    return handleAxiosError(error)
  }
}
//post
export const postOrdenServicioCorporativo = async (data: CreateServicioCorporativaParams) => {
  return post<IOrdenServicioCorporativo>(`${urlBackend}api/v1/OrdenServicioCorporativo/`, data, true);
}
//put 
export const putOrdenServicioCorporativo = async ({ id, data }: UpdateServicioCorporativaParams) => {
  return put<IOrdenServicioCorporativo>(`${urlBackend}api/v1/OrdenServicioCorporativo/${id}/`, data, true)
}
